module.exports = __webpack_public_path__ + "img/grin.9103517d.svg";